module.exports = __webpack_public_path__ + "static/9-7725f041f4a6440e8f8aaf554b4be3cc.png";